/**
 * Décision 343 — la note de l'accueil pour la chargée : ce qui se lit, et ce
 * qui s'écrit. Rien de médical.
 */
import { z } from 'zod';
import { NOTE_CHARGEE_MAX } from '../rules/note-chargee.js';
/**
 * S1405 (D1) — un caractère de contrôle (le nul surtout, que PostgreSQL
 * refuse dans un texte) est un 400, pas une erreur interne. Le retour à la
 * ligne et la tabulation restent permis.
 */
export function sansCaractereDeControle(texte) {
    for (const c of texte) {
        const code = c.charCodeAt(0);
        if ((code < 0x20 && c !== '\n' && c !== '\r' && c !== '\t') || code === 0x7f)
            return false;
    }
    return true;
}
export const MESSAGE_CARACTERE_DE_CONTROLE = 'Le texte contient un caractère invisible non accepté.';
const texteDeNote = z
    .string()
    .trim()
    .max(NOTE_CHARGEE_MAX, `La note tient en ${String(NOTE_CHARGEE_MAX)} caractères au plus.`)
    .refine(sansCaractereDeControle, MESSAGE_CARACTERE_DE_CONTROLE);
export const schemaNoteChargee = z.object({
    texte: z.string(),
    /** Le nom de l'accueil qui l'a écrite ou modifiée en dernier. */
    auteur: z.string().nullable(),
    ecriteLe: z.iso.datetime(),
});
/** Écrire ou modifier la note ; un texte vide la retire. */
export const schemaSaisieNoteChargee = z.object({ texte: texteDeNote }).strict();
/** La note d'une fiche, pour qui peut la lire, et si ce lecteur peut encore la modifier. */
export const schemaNoteChargeeDeLaFiche = z.object({
    note: schemaNoteChargee.nullable(),
    modifiable: z.boolean(),
});
/** À l'enrôlement : facultative, vide = aucune. */
export const champNoteChargeeALEnrolement = texteDeNote.nullish();
//# sourceMappingURL=note-chargee.js.map